import * as webElectron from "../web/webElectron"

import "./utils/polyfills"

// eslint-disable-next-line import/newline-after-import
;(async () => {
  const { preload } = await import("shared/shared.preload")
  await preload(webElectron)
  const { initWebAppServices } = await import("web")
  await initWebAppServices()
  const { loadRoot } = await import("./loadRoot")
  loadRoot()
})()
